const getDirectionsImplementation = require("./directionsinterface");

module.exports = {
    getDirectionsImplementation,
};
